(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-text-and-slideshow"] && !Shopify.designMode) return;
  try {
    
  class CustomTextSlideshow {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId;
      this.textColumn = this.section.querySelector(`#cts-text-column-${this.sectionId}`);
      this.autoplay = section.dataset.autoplay === 'true';
      this.delay = parseInt(section.dataset.delay, 10);
      this.textSlides = this.section.querySelectorAll('.cts-text-slide');
      this.imageSlides = this.section.querySelectorAll('.cts-image-slide');
      this.dots = this.section.querySelectorAll('.cts-dot');
      
      this.prevButtons = this.section.querySelectorAll('.cts-nav-button--prev');
      this.nextButtons = this.section.querySelectorAll('.cts-nav-button--next');

      if (this.textSlides.length === 0) return;

      this.currentIndex = 0;
      this.autoplayInterval = null;
      this.isPaused = false;
      this.isVisible = false;
      this.hasStarted = false; // Tracks if the initial animation has played
    }

    init() {
      // Intersection Observer: Only play when visible
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            this.isVisible = true;

            // Trigger the first slide animation ONLY when the section is seen
            if (!this.hasStarted) {
                this.goToSlide(0, true);
                this.hasStarted = true;
            }

            if (this.autoplay && !this.isPaused) {
               this.startAutoplay();
            }
          } else {
            this.isVisible = false;
            this.stopAutoplay();
          }
        });
      }, { threshold: 0.25 }); // Reduced threshold slightly for better mobile triggering
      
      observer.observe(this.section);

      if (this.textSlides.length <= 1) {
        const navWrappers = this.section.querySelectorAll('.cts-navigation-wrapper');
        navWrappers.forEach(el => el.style.display = 'none');
        return;
      }

      // Event Listeners
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.manualChange(parseInt(dot.dataset.slideIndex, 10));
        });
      });

      if (this.prevButtons) {
        this.prevButtons.forEach(btn => btn.addEventListener('click', () => {
            let prevIndex = (this.currentIndex - 1 + this.textSlides.length) % this.textSlides.length;
            this.manualChange(prevIndex);
        }));
      }
      if (this.nextButtons) {
        this.nextButtons.forEach(btn => btn.addEventListener('click', () => {
            let nextIndex = (this.currentIndex + 1) % this.textSlides.length;
            this.manualChange(nextIndex);
        }));
      }

      // Pause on hover
      this.section.addEventListener('mouseenter', () => {
          this.isPaused = true;
          this.stopAutoplay();
      });
      
      this.section.addEventListener('mouseleave', () => {
          this.isPaused = false;
          // Only resume if we have actually started and are visible
          if(this.isVisible && this.autoplay && this.hasStarted) this.startAutoplay();
      });
    }

    manualChange(index) {
        this.goToSlide(index);
        this.resetAutoplay();
    }

    goToSlide(index, isInitial = false) {
      // Logic update: Allow index 0 to re-fire if it's the initial start
      if (index === this.currentIndex && !isInitial && this.hasStarted) return;

      const previousIndex = this.currentIndex;
      this.currentIndex = index;

      const currentTextSlide = this.textSlides[this.currentIndex];
      const previousTextSlide = this.textSlides[previousIndex];
      const currentImageSlide = this.imageSlides[this.currentIndex];
      const previousImageSlide = this.imageSlides[previousIndex];
      
      // Update dots
      this.dots.forEach(dot => {
         if(parseInt(dot.dataset.slideIndex) === this.currentIndex) {
             dot.classList.add('is-active');
         } else {
             dot.classList.remove('is-active');
         }
      });

      // Slide Switching Logic
      // Only remove class if we aren't initializing the very first slide
      if (this.hasStarted && previousTextSlide) previousTextSlide.classList.remove('is-active');
      
      if (this.hasStarted && previousImageSlide) {
        previousImageSlide.classList.remove('is-active');
        this.controlMedia(previousImageSlide, 'pause');
      }

      // Force a slight reflow for browser to catch the transition if needed
      if (currentTextSlide) {
        // Ensure color changes happen
        const newBgColor = currentTextSlide.dataset.bgColor;
        const newTextColor = currentTextSlide.dataset.textColor;
        this.textColumn.style.backgroundColor = newBgColor;
        this.textColumn.style.color = newTextColor;
        
        // Add active class
        currentTextSlide.classList.add('is-active');
      }

      if (currentImageSlide) {
        currentImageSlide.classList.add('is-active');
        this.controlMedia(currentImageSlide, 'play');
      }
    }

    controlMedia(slide, action) {
        const media = slide.querySelector('video, iframe');
        if (!media) return;

        if (action === 'pause') {
            if (media.tagName === 'VIDEO') media.pause();
            if (media.tagName === 'IFRAME') {
                if(media.src.includes('youtube')) media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                if(media.src.includes('vimeo')) media.contentWindow.postMessage('{"method":"pause"}', '*');
            }
        }
        if (action === 'play') {
            if (media.tagName === 'VIDEO') media.play().catch(() => {});
            if (media.tagName === 'IFRAME') {
                if(media.src.includes('youtube')) media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                if(media.src.includes('vimeo')) media.contentWindow.postMessage('{"method":"play"}', '*');
            }
        }
    }

    startAutoplay() {
      if (this.autoplayInterval) clearInterval(this.autoplayInterval);
      
      this.autoplayInterval = setInterval(() => {
        let nextIndex = (this.currentIndex + 1) % this.textSlides.length;
        this.goToSlide(nextIndex);
      }, this.delay);
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }

    resetAutoplay() {
      if (this.autoplay && this.isVisible && !this.isPaused) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const slideshowSections = document.querySelectorAll('.cts[data-section-id]');
    slideshowSections.forEach(section => {
      const slider = new CustomTextSlideshow(section);
      slider.init();
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.cts[data-section-id]');
    if (section) {
      const slider = new CustomTextSlideshow(section);
      slider.init();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
